<template>
  <div>
    <Navbar />
    <div class="step-page">
      <div class="title">
        <span style="font-size: 1.8rem; font-weight: bold"
          >DL 直接人員面談資料表</span
        ><br />
        <span class="en-text">DL Interview Information Form</span>
      </div>

      <div class="title">
        <span style="font-weight: bold"
          >應徵生產助理員、作業員、技術員、生產技術員、助理等職務<br
        /></span>
        <span class="en-text"
          >Apply for production assistant, operator, technician, production
          technician</span
        >
      </div>

      <el-tabs
        v-model="activeName"
        :tab-position="windowWidth > 1024 ? 'left' : 'top'"
        class="tab-component"
      >
        <el-tab-pane label="面談背景資料" name="面談背景資料">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsDLWorkedInfoComplete }"
          >
            <span class="tab-name">
              面談背景資料<br />
              Interview background
            </span>
          </span>
          <div class="step-content no-bg mt-1">
            <WorkedInfo
              v-if="activeName === '面談背景資料'"
              :source="'resume'"
              :key="workedInfoKey"
              :nextTab="'個人資料'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="個人資料" name="個人資料">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsDLBaseInfoComplete }"
          >
            <span class="tab-name">
              個人資料<br />
              Personal information
            </span>
          </span>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              **
              以下任何欄位皆基於工作所需而請求應徵者提供，若認為涉及個人資料而不願透漏，可選擇不填。<br />
              <span class="en-text"
                >The applicant must fill out the following fields based on job
                requirements, if do not want to disclose personal information,
                can select not to fill out.</span
              >
            </div>
            <BaseInfo
              v-if="activeName === '個人資料'"
              :source="'resume'"
              :key="baseInfoKey"
              :nextTab="'工作條件'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane label="工作條件" name="工作條件">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsDLWorkConditionComplete }"
          >
            <span class="tab-name">
              工作條件<br />
              Work Conditions
            </span>
          </span>
          <div class="step-content no-bg">
            <WorkCondition
              v-if="activeName === '工作條件'"
              :source="'resume'"
              :key="workConditionKey"
              :nextTab="'學歷'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="學歷" name="學歷">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsDLEducationComplete }"
          >
            <span class="tab-name">
              學歷<br />
              Education
            </span>
          </span>
          <div class="step-content no-bg">
            <Education
              v-if="activeName === '學歷'"
              :source="'resume'"
              :key="educationKey"
              :nextTab="'工作經歷'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane label="工作經歷" name="工作經歷">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsDLWorkExperienceComplete }"
          >
            <span class="tab-name">
              工作經歷<br />
              Work Experience
            </span>
          </span>
          <div class="step-content no-bg">
            <WorkExperience
              v-if="activeName === '工作經歷'"
              :source="'resume'"
              :key="workExperienceKey"
              :nextTab="'專業技能'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane label="專業技能" name="專業技能">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsDLSkillComplete }"
          >
            <span class="tab-name">
              專業技能<br />
              Professional skills
            </span>
          </span>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              ** 請填寫具備的電腦技能、培訓紀錄、證照檢定、工作專長<br />
              <span class="en-text"
                >Please fill out if you possess computer skills, training
                records, work skill</span
              >
            </div>
            <Skill
              v-if="activeName === '專業技能'"
              :source="'resume'"
              :key="skillKey"
              :nextTab="'自傳'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="自傳" name="自傳">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLAutobiographyComplete }"
          >
            <span class="tab-name">
              自傳<br />
              Autobiography
            </span>
          </span>
          <div class="step-content no-bg">
            <Autobiography
              v-if="activeName === '自傳'"
              :source="'resume'"
              :key="autobiographyKey"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Navbar from "@/components/candidate/NavBar";
import WorkedInfo from "@/components/customize/Front/DL/WorkedInfo";
import BaseInfo from "@/components/customize/Front/DL/BaseInfo";
import WorkCondition from "@/components/customize/Front/DL/WorkCondition";
import Education from "@/components/customize/Front/DL/Education";
import WorkExperience from "@/components/customize/Front/DL/WorkExperience";
import Skill from "@/components/customize/Front/DL/Skill";
import Autobiography from "@/components/customize/Front/DL/Autobiography";

export default {
  name: "AseDLResume",

  components: {
    Navbar,
    WorkedInfo,
    BaseInfo,
    WorkCondition,
    Education,
    WorkExperience,
    Skill,
    Autobiography,
  },
  data() {
    return {
      activeName: "面談背景資料",

      workedInfoKey: 0,
      baseInfoKey: 0,
      workConditionKey: 0,
      educationKey: 0,
      workExperienceKey: 0,
      skillKey: 0,
      autobiographyKey: 0,

      windowWidth: 0,
      timer: 0,
    };
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    changeTab(name) {
      this.timer = setTimeout(() => {
        this.activeName = name;
      }, 1500);
    },
  },

  watch: {
    activeName: function (newVal) {
      switch (newVal) {
        case "面談背景資料":
          this.workedInfoKey += 1;
          break;
        case "個人資料":
          this.baseInfoKey += 1;
          break;
        case "工作條件":
          this.workConditionKey += 1;
          break;
        case "學歷":
          this.educationKey += 1;
          break;
        case "工作經歷":
          this.workExperienceKey += 1;
          break;
        case "專業技能及認證":
          this.skillKey += 1;
          break;
        case "自傳":
          this.autobiographyKey += 1;
          break;
        default:
          this.workedInfoKey += 1;
      }
    },
  },

  computed: {
    ...mapGetters(["resumeCompleteness"]),
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },

  destroyed() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.step-tip {
  color: #fff;
  font-size: 0.85em;
}

.tab-name {
  display: inline-block;
  line-height: 20px;
}

/deep/ .el-tabs__content {
  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-button {
    background: transparent;

    border-radius: 4px;
  }

  &::-webkit-scrollbar-track-piece {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;

    background-color: rgba(0, 0, 0, 0.4);

    border: 1px solid slategrey;
  }

  &::-webkit-scrollbar-track {
    box-shadow: transparent;
  }

  @media screen and (min-width: 768px) {
    height: calc(100vh - 175px);
    overflow: auto;
  }
}

/deep/ .tab-component {
  .el-tabs__item {
    color: #fff;
    height: 55px;

    &.is-active {
      color: #22c59a;
    }
  }

  .el-tabs__active-bar {
    background-color: #22c59a;
  }

  .important-table {
    width: 90%;
    max-width: 680px;
    margin: 0 auto;

    th {
      color: #fff;
      padding: 10px;
      text-align: center;
    }
    td {
      padding: 10px;
      input,
      select {
        border: none;
        border-radius: 25px;
        width: 100%;
        line-height: 30px;
        height: 30px;
        padding: 0 10px;
      }
    }
  }
}

/deep/ .el-input--prefix .el-input__inner {
  padding-left: 30px !important;
}

/deep/ .el-icon-arrow-left:before {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
}
/deep/ .el-icon-arrow-right:before {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
}

.title {
  color: #fff;
  text-align: center;
  margin-bottom: 10px;
}

.en-text {
  opacity: 0.6;
  font-size: 0.9em;
}
</style>
